/**
 * T-25 — catch-surface microcopy (spec §7d / §8.2, DS-1g-04). Static template
 * strings in ONE module: dedup-ASK, walk-of-shame (oldest-first) labeling,
 * and the client-guard second confirm (§4.7). NEVER LLM-generated — no
 * function here reaches a model call, ever (AC-1g-25's static-string audit,
 * enforced by the grep guard in microcopy-guard.test.ts). Stage-B wording
 * polish edits ONLY this module (the second §0 allowlist delta).
 */

/** dedup-ASK (Turn A prompt shown to the human; §3.1/§8.1). `subject` is the
 * plain extraction-derived text of the candidate match — never a model
 * paraphrase, just interpolated verbatim into a fixed template. */
export function dedupAskPrompt(subject: string): string {
  return `You logged this one Tuesday — same thing? "${subject}"`;
}

export const DEDUP_ASK_CONFIRM_LABEL = "Yes, same thing";
export const DEDUP_ASK_CORRECT_LABEL = "No, something else";

/** Walk-of-shame framing (§6, DS-1g-06): oldest-first is the PRIMARY and
 * only ordering for the decision list — this label is descriptive copy
 * only, never a control that could re-order the list. */
export const WALK_OF_SHAME_LABEL = "Oldest open items first";

/** The §4.7 client-report double-confirm (T-13's UI reads this, never
 * composes its own string). One fixed template — no interpolation, so
 * there is no path for report content to leak into the confirm copy. */
export const CLIENT_REPORT_SECOND_CONFIRM = "Send to the CLIENT's report?";
export const CLIENT_REPORT_FIRST_CHOICE_LABEL = "Client report";

/** Photo-context gate (T-10, §3.2) — the two required questions. */
export const PHOTO_CONTEXT_ROOM_PROMPT = "What room is this?";
export const PHOTO_CONTEXT_ACTION_PROMPT = "What do you want done with it?";

/** §2.2 part-count bound (T-21; also referenced by ActiveCapture's own
 * inline copy — kept here too so later screens can reuse the same string
 * without re-deriving it). */
export const PART_LIMIT_REACHED = "Photo limit reached (20 parts max)";

/** Finalize/undo copy (T-14, §4.2/§4.3). `seconds` is the remaining grace
 * window; a fixed template, never a generated status line. */
export function undoToastLabel(seconds: number): string {
  return `Saved — Undo (${seconds}s)`;
}

export const REJECTED_CARD_LABEL = "Couldn't send — tap to retry or edit";

/** aging-item catch copy (fixture dormant-pass leg, AC-1g-30 sibling event
 * `aging_opened` — the label rendered on an aged, still-open decision. */
export function agingOpenedLabel(ageDays: number): string {
  return `Open for ${ageDays} day${ageDays === 1 ? "" : "s"}`;
}

/** Save screen: the local save failed or hung (iPhone Safari silent-save,
 * 2026-10-01). The entry stays on screen, so retrying loses nothing. */
export const SAVE_FAILED = "Couldn't save this entry. It's still here — tap Save to try again.";
export const SAVE_TIMED_OUT = "Couldn't save this entry: saving took too long. It's still here — tap Save to try again.";
